import { Timestamp } from "firebase/firestore";
import { SearchHelper } from "../../utils/helpers";

export const employeeToFirestore = (data, tenantData, authUser, roles = []) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    const tenantName = typeof tenantData === 'string' ? '' : (tenantData?.tenantName || tenantData?.name || '');
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const firstName = data.firstName?.trim() || "Novo";
    const lastName = data.lastName?.trim() || "Colaborador";
    const fullName = `${firstName} ${lastName}`;

    // Encontrar o nome do cargo para salvar denormalizado
    let roleName = data.roleName || "";
    if (!roleName && data.role) {
        if (data.role === 'admin') roleName = "Administrador";
        else if (data.role === 'owner') roleName = "Dono / Sócio";
        else {
            const roleObj = roles.find(r => r.id === data.role);
            roleName = roleObj ? roleObj.name : "";
        }
    }

    const payload = {
        idTenant,
        tenantName,
        firstName,
        lastName,
        fullName, // Campo consolidado unificado como pedido
        searchName: SearchHelper.normalize(fullName),
        email: data.email?.toLowerCase().trim() || "",
        role: data.role, // ID do Role
        roleName, // Nome amigável do Role resolvido do array roles
        status: data.status,
        phone: data.phone,
        cpf: data.cpf,
        gender: data.gender,
        birthDate: data.birthDate,
        photoUrl: data.photoUrl,
        professionalRegistration: data.professionalRegistration,
        address: {
            zipCode: data.address?.zipCode,
            state: data.address?.state,
            city: data.address?.city,
            neighborhood: data.address?.neighborhood,
            street: data.address?.street,
            number: data.address?.number},

        xpTotal: data.xpTotal,

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (data.id && data.createdBy) ? data.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Remove undefined
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados do Firestore para o React.
 */
export const employeeFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
